import { Link } from "react-router-dom";
import { useState } from "react";
import logo from "../assets/wml.webp";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="navbar">

      {/* LOGO - always visible */}
      <div className="nav-left">
        <img src={logo} alt="Logo" className="logo" />

        {/* DESKTOP LINKS */}
        <div className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/about">Our Mission</Link>
          <Link to="/run">Watermelon Run</Link>
          <Link to="/tutoring-program">Tutoring Program</Link>
          <Link to="/faq">FAQs</Link>
        </div>
      </div>

      {/* DESKTOP BUTTONS */}
      <div className="nav-buttons desktop-only">
        <Link to="/contact" className="pink-btn">Contact</Link>
        <Link to="/donate" className="pink-outline">Donate</Link>
      </div>

      {/* MOBILE RIGHT SIDE - Donate + Hamburger */}
      <div className="mobile-nav-right">
        <Link to="/donate" className="pink-outline" style={{ fontSize: "13px", padding: "8px 16px" }}>
          Donate
        </Link>
        <button
          className="hamburger-btn"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* MOBILE DROPDOWN MENU */}
      {menuOpen && (
        <div className="mobile-menu" onClick={() => setMenuOpen(false)}>
          <Link to="/">Home</Link>
          <Link to="/about">Our Mission</Link>
          <Link to="/run">Watermelon Run</Link>
          <Link to="/tutoring-program">Tutoring Program</Link>
          <Link to="/faq">FAQs</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/donate" className="pink-btn" style={{ textAlign: "center" }}>Donate</Link>
        </div>
      )}

    </div>
  );
}